export default "__VITE_ASSET__waDHjILm__"